import { redirect } from 'react-router-dom'

const ORDERED_DEFAULT_ONBOARDING_ROUTES = ['usually-sound', 'caution-level']

const HIGH_ALERT_ROUTES = [
  'red-flags',
  'opener',
  'message-values',
  'tips',
  'reply-behavior',
  'reply-speed',
  'dating-mood',
  'complete-sentence',
  'synced',
]
const OTHER_CAUTION_ROUTES = [
  'vibe',
  'opener',
  'message-values',
  'tips',
  'reply-behavior',
  'reply-speed',
  'dating-mood',
  'complete-sentence',
  'synced',
]

// Store the updated routes array to avoid recalculating
let updatedOnboardingRoutes = [...ORDERED_DEFAULT_ONBOARDING_ROUTES]

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()
  const currentPage = request.url.split('/').pop()?.split('?')[0]

  // Update routes array only when we reach caution-level page
  if (currentPage === 'caution-level') {
    const answer = formData.get('answer') as string

    if (answer === 'highAlert') {
      // If high alert selected: usually-sound -> caution-level -> red-flags -> vibe
      updatedOnboardingRoutes = [
        ...ORDERED_DEFAULT_ONBOARDING_ROUTES,
        ...HIGH_ALERT_ROUTES,
      ]
    } else {
      // If other options selected: usually-sound -> caution-level -> vibe (skip red-flags)
      updatedOnboardingRoutes = [
        ...ORDERED_DEFAULT_ONBOARDING_ROUTES,
        ...OTHER_CAUTION_ROUTES,
      ]
    }
  }

  const next = getNext(request.url, updatedOnboardingRoutes)

  if (!next) return redirect('/sign-up/company')

  const nextPathname = getNextPathName({ next, url: request.url })

  if (currentPage === 'success') {
    const hash = formData.get('success') as string
    return redirect(`${nextPathname}#${hash}`)
  } else {
    return redirect(nextPathname)
  }
}

function getNext(url: string, routes: string[]): string | undefined {
  const pathname = new URL(url).pathname
  const current = pathname.split('/').pop()

  if (!current) return

  const currentIndex = routes.indexOf(current)
  const next = routes[currentIndex + 1]

  return next
}

function getNextPathName({ next, url }: { next: string; url: string }): string {
  const currentPathname = new URL(url).pathname
  const paths = currentPathname.split('/')
  const basePathname = paths.slice(0, -1).join('/')
  const nextPathname = basePathname + '/' + next
  return nextPathname
}
